import WebCheck from './views/webcheck'

export default {
  module: {
    name: 'WebCheck',
    icon: '',
    defaultPath: '/',
    permission: '',
    pages: [
      {title: 'WebCheck', path: '/', component: WebCheck, menu: false, breadcrumb: false, loginNotRequired: true}
    ]
  }
}